import { path } from 'ramda';
import { IOfferState } from '../../redux/reducers';

/**
 *
 * @description Возвращает id бизнес-центра
 */
export function getBusinessCenterId(offer: IOfferState): number | undefined {
  return path<number>(['businessShoppingCenter', 'id'], offer);
}
